import * as React from "react";
import Divider from 'material-ui/Divider';
import { Card, CardHeader, CardText, CardTitle } from 'material-ui/Card';
import { EstructuraEmpresa, EstructuraSuraEmpresa } from "../modelo/EstructuraEmpresa";

const estiloCabeceraCard = {
    display: 'flex', 
    justifyContent:'center', 
    alignItems:'center', 
    textalign:'center', 
    fontSize: '20px',
    color: '#023a86',
    fontFamily: 'Roboto, sans-serif'
};

export default class ContenidoPestañaEmpresa extends React.Component<ContenidoPestañaEmpresaProps, any> {
    
    render() {
        const {estructuraEmpresa, estructuraSuraEmpresa} = this.props;
        const razonSocial = estructuraEmpresa.razonSocial ? estructuraEmpresa.razonSocial : '-';

        return (
            <div>
                <Card>
                    <CardHeader
                        title={<b>{razonSocial}</b>}
                        subtitle={
                            <b>
                                <div style={this.agregarEstilo(estiloCabeceraCard, {fontSize: '15px'})}>
                                    {estructuraEmpresa.tipoDocumentoEmpleador} - {estructuraEmpresa.numeroDocumentoEmpleador}
                                </div>
                                {
                                    estructuraSuraEmpresa && 
                                    (
                                        <span>
                                            <div style={this.agregarEstilo(estiloCabeceraCard, {fontSize: '12.5px'})}>
                                                Inicio Cobertura SURA {estructuraSuraEmpresa.fechaInicio}
                                            </div>
                                            <div style={this.agregarEstilo(estiloCabeceraCard, {fontSize: '12.5px'})}>
                                                Póliza {estructuraSuraEmpresa.poliza}
                                            </div>
                                        </span>
                                    )
                                }
                            </b>
                        }
                        style={{display: 'flex', justifyContent:'center', alignItems:'center', textalign:'center', paddingLeft: '130px'}}
                        titleStyle={this.agregarEstilo(estiloCabeceraCard, {marginTop: '20px'})}
                        subtitleStyle={this.agregarEstilo(estiloCabeceraCard, {fontSize: '15px'})}
                    />
                    <CardTitle title={this.props.tituloCabecera} titleStyle={{marginBottom: '-30px', fontSize: '20px', color: '#023a86'}}/>
                    <CardText>
                        <Divider/>
                        <div style={{marginTop: '30px'}}>
                            {this.props.contenido}
                        </div>
                    </CardText>
                </Card>
            </div>
        );
    }

    agregarEstilo = (estilos, nuevosEstilos) => {
        const estiloModificado = {...estilos};
        const objeto = Object.keys(nuevosEstilos);
        objeto.forEach(estilo => {
            estiloModificado[estilo] = nuevosEstilos[estilo];
        });
        return estiloModificado;
    };
}

interface ContenidoPestañaEmpresaProps {
    estructuraEmpresa: EstructuraEmpresa,
    estructuraSuraEmpresa?: EstructuraSuraEmpresa,
    tituloCabecera: string,
    contenido: any
}


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/estructura_empresas/componentes/ContenidoPestañaEmpresa.tsx